import { useEffect } from 'react';
import { useFloating, autoUpdate, hide, offset } from '@floating-ui/react';
import { getFloatingUIPlacement } from '../../utils/placement';
import { jsx as _jsx } from "react/jsx-runtime";
const FloatyWrapper = ({
  children,
  onTipRender,
  onTipUnmount,
  placement = 'bottom right',
  target,
  zIndex,
  isEmptyTarget = false
}) => {
  var _middlewareData$hide;
  const mappedPlacement = getFloatingUIPlacement(placement);
  const {
    floatingStyles,
    refs,
    middlewareData,
    update
  } = useFloating({
    placement: mappedPlacement,
    middleware: [offset(({
      rects
    }) => ({
      alignmentAxis: -rects.floating.width / 2,
      mainAxis: -rects.floating.height / 2
    })), hide()],
    open: true,
    elements: {
      reference: target
    },
    whileElementsMounted: autoUpdate
  });

  // some applications are using an empty div to position the tip button, which doesn't update correctly
  // just adding an unbreakable space inside fix this
  useEffect(() => {
    if (target && isEmptyTarget) {
      if (!target.innerHTML) {
        target.innerHTML = '&nbsp;';
      }
    }
  }, [target, isEmptyTarget]);

  // This handles legacy repositioning callbacks that may still be in use,
  // though floating-ui's built-in positioning likely makes this redundant now
  useEffect(() => {
    if (onTipRender) {
      onTipRender({
        reposition: update
      });
    }
    return () => {
      if (onTipUnmount) {
        onTipUnmount();
      }
    };
  }, [update, onTipRender, onTipUnmount]);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "floaty-wrapper",
    ref: refs.setFloating,
    style: Object.assign({}, floatingStyles, {
      zIndex,
      // The visibility logic here is overridden by useTarget hook in CoachingTip
      // Currently useTarget handles both visibility and unmounting, but it should be split:
      // - FloatyWrapper should handle visibility via floating-ui's hide middleware
      // - useTarget should only handle unmounting when target elements are removed
      visibility: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 'hidden' : 'visible'
    }),
    children: children
  });
};
export default FloatyWrapper;